import { render, staticRenderFns } from "./Despacho.vue?vue&type=template&id=f0c7fed4"
import script from "./Despacho.vue?vue&type=script&lang=js"
export * from "./Despacho.vue?vue&type=script&lang=js"
import style0 from "./Despacho.vue?vue&type=style&index=0&id=f0c7fed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports